import styled from "styled-components"

export const VoterRegistrationIframe = styled.iframe`
    height: 900px;
    margin-bottom: 10px;
    margin-top: 10px;
    width: 100%;
    border: none;
`
